import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Building2, Users, Network } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import DepartmentManagement from "@/components/team/DepartmentManagement";
import PersonnelManagement from "@/components/team/PersonnelManagement";
import OrgChart from "@/components/team/OrgChart";

const Team = () => {
  const { company } = useAuth();
  const [activeTab, setActiveTab] = useState("members");

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <h1 className="text-3xl font-medium text-foreground">Team Management</h1>
          <p className="text-muted-foreground">
            Manage team members, departments, and organizational structure for {company?.name || 'your company'}.
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="members" className="flex items-center gap-2">
            <Users className="w-4 h-4" />
            Team Members
          </TabsTrigger>
          <TabsTrigger value="departments" className="flex items-center gap-2">
            <Building2 className="w-4 h-4" />
            Departments
          </TabsTrigger>
          <TabsTrigger value="orgchart" className="flex items-center gap-2">
            <Network className="w-4 h-4" />
            Org Chart
          </TabsTrigger>
        </TabsList>

        {/* Team Members Tab - All management features consolidated here */}
        <TabsContent value="members">
          <PersonnelManagement />
        </TabsContent>

        {/* Departments Tab */}
        <TabsContent value="departments">
          <DepartmentManagement />
        </TabsContent>

        {/* Org Chart Tab */}
        <TabsContent value="orgchart">
          <OrgChart />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Team;